<template>
  <div id="app">
<!--    <div style="top: 200px;right: 10px;z-index: 100;position: fixed">-->
<!--      <div style="position: relative">-->
<!--        <img src="../static/img/icon1.png" v-if="isTel" alt="" style="width: 52px;height: 52px;cursor: pointer"-->
<!--             @click="getTel">-->
<!--        <img src="../static/img/icon17.png" v-if="!isTel" alt="" style="width: 52px;height: 52px;cursor: pointer"-->
<!--             @click="getTel">-->
<!--        <div class="telbox" v-if="isTel">-->
<!--          18625216693-->
<!--        </div>-->
<!--      </div>-->
<!--      <div style="position: relative">-->
<!--        <img src="../static/img/icon2.png" alt="" v-if="isCode" style="width: 52px;height: 52px;cursor: pointer"-->
<!--             @click="getCode">-->
<!--        <img src="../static/img/icon18.png" alt="" v-if="!isCode" style="width: 52px;height: 52px;cursor: pointer"-->
<!--             @click="getCode">-->
<!--        <div style="position: absolute;top: 0;right: 52px" v-if="isCode">-->
<!--          <img src="../static/img/code.png" alt="" style="width: 102px;height: 102px">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!--    <div style="position: fixed;top: 400px;right: 150px;z-index: 100;cursor: pointer">-->
    <!--      <img src="../static/img/img2.png" alt="" style="width: 100px;height: 100px">-->
    <!--    </div>-->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
    export default {
        name: 'App',
        provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isTel: false,
                isCode: false,
                isRouterAlive: true                    //控制视图是否显示的变量
            }
        },
        mounted() {

        },
        methods: {
            getCode() {
                this.isCode = !this.isCode
            },
            getTel() {
                this.isTel = !this.isTel
            }
        }
    }
</script>

<style>
  html {
    background-color: #f9fafc;
  }

  .telbox {
    width: 150px;
    height: 52px;
    background: #FFFFFF;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    font-size: 16px;
    color: #262626;
    line-height: 52px;
    text-align: center;
    position: absolute;
    top: 0;
    right: 52px;

  }

  img[lazy="loading"] {
    width: 30px;
    height: 30px;
  }

  .el-popover {
    border: none !important;
    background: none;
    padding: 0 !important;
  }

  ::-ms-clear, ::-ms-reveal {
    display: none;
  }

  li {
    list-style: none;
  }

  .flex-between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .flex {
    display: flex;
    flex-direction: row;
  }

  .flex-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .flex-around {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  #app {
    height: 100%;
    width: 100%;

  }

  * {
    margin: 0;
    padding: 0;
  }

  img {
    width: 100%;
    display: block;
  }

  body {
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue